<template>
  <div class="takeOver flexcenter">
    <transition>
      <!-- 引継ぎコード発行 -->
      <div v-if="!issued" class="issuing flexcenter">
        <div class="modal-close" @click="$emit('close')"></div>
        <h3 class="lbold font22">引継ぎコード発行</h3>
        <div class="mb20 font14 divider-top">
          <div>学習情報の引継ぎには引継ぎコードとパスワードが必要です</div>
          <div>パスワードを設定し引継ぎコードを発行してください</div>
        </div>
        <div class="password flexcenter">
          <input type="password" v-model="password" placeholder="パスワード (英数半角4～16文字)" maxlength="16" @keypress.enter="issueing()">
          <button class="enter" @click="issueing()"><img src="static/images/icon/svg/ar_r_login.svg" alt="issueing"></button>
        </div>
        <p class="error m0" v-if="message && !issued">{{ message }}</p>
      </div>
      <!-- 引継ぎコード発行完了 -->
      <div v-else class="issuing flexcenter">
        <div class="modal-close" @click="$emit('close')"></div>
        <h3 class="lbold font22">引継ぎコード</h3>
        <div class="code flexcenter font20 divider-top">{{ takeOverCode }}</div>
        <div class="mt30 font14">学習情報の引継ぎには引継ぎコードとパスワードが必要です</div>
      </div>
    </transition>
  </div>
</template>

<script>
import * as constants from '@/mixin/constants';
import common from '@/mixin/common';
import http from '@/mixin/http';

export default {
  name: 'takeOver',
  data: function () {
    return {
      password: '',
      message: '',
      issued: false,
      takeOverCode: '',
    }
  },
  mixins: [
    common,
    http,
  ],
  methods: {
    /**
     * 引継ぎコード発行
     */
    issueing: function () {
      var self = this;
      this.log("TakeOver start issueing");

      // 入力値検証
      if (!this.password.match(/^[0-9a-z]{4,16}$/)) {
        this.error(constants.ERR_TAKEOVER_PASSWORD);
        return;
      }

      // 引き継ぎコード取得APIを実行
      this.getTakeOverCode(this.password).then(function (response) {
        self.log("TakeOver getTakeOverCode resultCode: " + response.result_code);
        switch (response.result_code) {
          case 'OK':
            self.takeOverCode = response.takeover_code;
            self.issued = true;
            break;
          default:
            self.error(constants.ERR_UNKNOWN);
            break;
        }
      }).catch(function (err) {
        self.error(constants.ERR_UNKNOWN);
      });
    },
    /**
     * エラー処理
     *
     * @param {String} message エラーメッセージ
     */
    error: function (message) {
      this.message = message;
      this.password = '';
    },
  },
  mounted: function () {
    this.log("TakeOver start mounted");
    this.setBodyStylePosition(true);
  },
  beforeDestroy: function () {
    this.log("TakeOver start beforeDestroy");
    this.setBodyStylePosition(false);
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// TakeOver.vue?d331bcc0